/**
 * @prettier
 */

import _has from 'lodash/has';

export const isCustomizationActive = customization =>
  _has(customization, 'inactive') ? !customization.inactive : !customization.deleted_at;
